import { connect } from 'react-redux/dist/react-redux';
import MapPage from '../components/MapPage';
function mapStateToProps(state) {
  return {
    agencesList: state.configuration.get('agenceList'),
  };
}
export default connect(mapStateToProps)(MapPage);
